import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const vehiclePositionLocaleModule: LocaleModule = {
  name: "vehiclePosition",
  messages: { en: en, it: it },
};
